import classNames from 'classnames';
import type { AllHTMLAttributes, ElementType } from 'react';
import { createElement, forwardRef } from 'react';

import type { Atoms } from '../../css/atoms/atoms.css';
import { atoms } from '../../css/atoms/atoms.css';

export interface BaseBoxProps extends Atoms {
  className?: string;
}

export interface BoxProps
  extends BaseBoxProps,
    Omit<AllHTMLAttributes<HTMLElement>, 'width' | 'height' | 'className'> {
  component?: ElementType;
}

/**
 * @deprecated Use Mantine alternatives instead:
 * - Container for page layout: import { Container } from '@mantine/core'
 * - Stack for vertical layout: import { Stack } from '@mantine/core'
 * - Group for horizontal layout: import { Group } from '@mantine/core'
 * - Paper for elevated surfaces: import { Paper } from '@mantine/core'
 */
export const Box = forwardRef<HTMLElement, BoxProps>(
  ({ component = 'div', className, ...restProps }, ref) => {
    const atomProps: Record<string, unknown> = {};
    const nativeProps: Record<string, unknown> = {};

    for (const key in restProps) {
      if (atoms.properties.has(key as keyof Atoms)) {
        atomProps[key] = restProps[key as keyof typeof restProps];
      } else {
        nativeProps[key] = restProps[key as keyof typeof restProps];
      }
    }

    const atomicClasses = atoms({ ...atomProps });
    const classes = classNames(className, atomicClasses);

    return createElement(component, {
      className: classes,
      ...nativeProps,
      ref,
    });
  },
);

Box.displayName = 'Box';

/**
 * @deprecated Use Mantine's Paper component instead.
 * Import: import { Paper } from '@mantine/core'
 * Use bg and radius props for styling.
 */
export const InsetBox = (props: BoxProps) => {
  return <Box background="neutralLight" borderRadius="large" {...props} />;
};
